import { topicNav } from "@/mocks/maydayContent";

const colorMap: Record<string, { bg: string; text: string; ring: string; icon: string }> = {
  primary: { bg: "bg-primary-100", text: "text-primary-700", ring: "group-hover:bg-primary-500", icon: "bg-primary-500" },
  accent: { bg: "bg-accent-100", text: "text-accent-800", ring: "group-hover:bg-accent-500", icon: "bg-accent-500" },
  secondary: { bg: "bg-secondary-100", text: "text-secondary-800", ring: "group-hover:bg-secondary-500", icon: "bg-secondary-500" },
};

export default function Topic() {
  return (
    <section id="topic" className="scroll-mt-24 w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between mb-8">
          <div>
            <div className="text-xs font-medium tracking-widest text-primary-600 mb-2">CORE TOPICS</div>
            <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">核心专题导航</h2>
          </div>
          <p className="max-w-sm text-sm text-foreground-500 sm:mb-1">四个方向、持续深挖，点击进入对应内容栏目。</p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {topicNav.map((t) => {
            const c = colorMap[t.color];
            return (
              <a
                key={t.id}
                href={`#${t.id}`}
                className="group relative flex flex-col justify-between overflow-hidden rounded-lg bg-background-100/70 border border-background-200/70 p-5 transition-colors hover:border-transparent"
              >
                <div className="flex items-start justify-between">
                  <span className={`flex h-12 w-12 items-center justify-center rounded-lg ${c.icon} text-background-50`}>
                    <i className={`${t.icon} text-xl w-6 h-6 flex items-center justify-center`}></i>
                  </span>
                  <span className={`text-[10px] font-semibold tracking-[0.2em] ${c.text}`}>{t.en}</span>
                </div>
                <div className="mt-6">
                  <h3 className="font-heading text-xl font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {t.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-foreground-600">{t.desc}</p>
                </div>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700">
                  进入栏目
                  <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1"></i>
                </span>
                <span className={`absolute inset-x-0 bottom-0 h-0.5 ${c.ring} transition-colors`}></span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}